// extracted by mini-css-extract-plugin
export default {"title":"ProfilePage_title__Cz0GF"};